import { render, staticRenderFns } from "./CookieModal.vue?vue&type=template&id=46421a25&"
import script from "./CookieModal.vue?vue&type=script&lang=js&"
export * from "./CookieModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports